/* eslint-disable import/no-unused-modules */
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import InputAdornment from '@mui/material/InputAdornment';
import { makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import { AddCircleOutline } from '@mui/icons-material';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import shadow from '../../helpers/shadow';
import { getUser } from '../../helpers/token';
import ProfileAvatar from '../Profile/ProfileAvatar';

const useStyles = makeStyles()(() => ({
  card: {
    borderRadius: 12,
    boxShadow: shadow.md,
  },
}));

export default function WritePostCard() {
  const { classes } = useStyles();

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  if (!user) return <></>;

  return (
    <div className="mt-2">
      <Link href="/dashboard/publish">
        <Card className={`${classes.card} ml-2 mr-2`}>
          <CardActionArea className="h-100">
            <CardContent>
              <div className="row">
                <div className="float-left pl-3">
                  <ProfileAvatar author={user} size={55} />
                </div>
                <div
                  className="ml-3 float-right"
                  style={{ width: 'calc(100% - 105px)' }}
                >
                  <TextField
                    id="write-a-post"
                    fullWidth
                    placeholder="Write a post..."
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AddCircleOutline color="primary" />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                  />
                </div>
              </div>
            </CardContent>
          </CardActionArea>
        </Card>
      </Link>
    </div>
  );
}
